<template>
  <div>
    <div class="label-template text-left mb-4">
      {{ categorySelected.PresentationsCategories.length }} {{ $i18nPresenter.t("templates") }}
    </div>
    <TemplateCard
      class="mb-6"
      v-for="itemCategory in categorySelected.PresentationsCategories"
      :key="itemCategory.id"
      :presentation="itemCategory.Presentation"
    />
  </div>
</template>
<script>
import TemplateCard from './TemplateCard.vue'

export default {
  components: {
    TemplateCard,
  },
  props: {
    categorySelected: {
      type: Object,
      default: () => {
        return {
          PresentationsCategories: [],
        }
      },
    },
  },
  data() {
    return {

    }
  },
}
</script>
<style scoped lang='scss'>
</style>
